import React from 'react';
import { Inbox } from 'lucide-react';

type NoDataStatus = 'no_data' | 'no_relevant_data' | 'no_relevant_results';

interface NoDataCardProps {
  status: NoDataStatus;
  message?: string;
  answer?: string;
}

const titleMap: Record<NoDataStatus, string> = {
  no_data: 'No Matching Opinions Found',
  no_relevant_data: 'No Relevant Data Found',
  no_relevant_results: 'No Relevant Results',
};

export const NoDataCard: React.FC<NoDataCardProps> = ({ status, message, answer }) => {
  const title = titleMap[status];

  // no_relevant_data uses the writer's explanation (answer), others use message
  const body = status === 'no_relevant_data'
    ? (answer || message || 'The search returned results, but none were relevant to your query.')
    : (message || 'No matching data was found for your query.');

  return (
    <div data-component="NoDataCard" className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div className="flex items-start gap-3">
        <Inbox className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" />
        <div>
          <div className="text-sm font-medium text-blue-800 mb-1">{title}</div>
          <div className="text-sm text-blue-700">{body}</div>
        </div>
      </div>
    </div>
  );
};
